/* src/app/quoting/pages/quote-accept/quote-accept.component.scss */
/*# sourceMappingURL=quote-accept.component.css.map */
